import type { CSSProperties, FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import Keyboard from '@/components/landing/keyboard'
import SoldOutButton from '@/components/landing/sold-out-button'

const DESK_UNIT = 'clamp(19px, calc((100vw - 8px) / 16.9), 59px)'
const DESK_FADE = 'linear-gradient(to bottom, #000 0%, #000 40%, rgb(0 0 0 / 0.55) 52%, rgb(0 0 0 / 0.2) 62%, transparent 72%)'

const DeskSection: FC = (): ReactNode => {
    return (
        <section id='desk' className='relative overflow-hidden px-6 pt-24 pb-10 sm:pt-36'>
            <Reveal className='mx-auto flex max-w-[520px] flex-col items-center text-center'>
                <h2 className='text-[28px] leading-[1.2] font-medium tracking-[-0.025em] text-white sm:text-[34px]'>
                    Everything that you love about Raycast, now on your desk
                </h2>

                <SoldOutButton className='mt-8' />
            </Reveal>

            <div
                className='relative -mx-6 mt-10 sm:mt-14'
                style={{ '--u': DESK_UNIT } as CSSProperties}
            >
                <div
                    aria-hidden='true'
                    className='pointer-events-none absolute top-[34%] left-1/2 h-[34%] w-[min(1100px,92%)] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgb(255_60_40/0.22),transparent)] blur-2xl'
                />

                <div style={{ maskImage: DESK_FADE, WebkitMaskImage: DESK_FADE, marginBlock: 'calc(var(--u) * -1.9)' }}>
                    <Keyboard
                        unit={DESK_UNIT}
                        tilt={66}
                        perspective={50}
                        variant='glow'
                        legends={false}
                        label='The Raycast Keyboard seen from the front at desk height, with red backlight glowing between the keys'
                        className='mx-auto'
                    />
                </div>
            </div>
        </section>
    )
}

export default DeskSection
